import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
